var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4987 14.6654C12.1806 14.6654 15.1654 11.6806 15.1654 7.9987C15.1654 4.3168 12.1806 1.33203 8.4987 1.33203C4.8168 1.33203 1.83203 4.3168 1.83203 7.9987C1.83203 11.6806 4.8168 14.6654 8.4987 14.6654Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4987 10.6654L8.4987 7.49854L8.4987 10.6654Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4987 5.33203H8.50537H8.4987Z",
    fill: "#FFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4987 10.6654L8.4987 7.49854M8.4987 5.33203H8.50537M15.1654 7.9987C15.1654 11.6806 12.1806 14.6654 8.4987 14.6654C4.8168 14.6654 1.83203 11.6806 1.83203 7.9987C1.83203 4.3168 4.8168 1.33203 8.4987 1.33203C12.1806 1.33203 15.1654 4.3168 15.1654 7.9987Z",
    stroke: "#E39F55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWarningIcon);
export default __webpack_public_path__ + "static/media/info-warning-icon.1f6e3ddd8c414337d3181c964c96632a.svg";
export { ForwardRef as ReactComponent };